const Unauthorized = () => {
  return (
    <div className="text-center p-4">
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default Unauthorized;
